import { indian_states_and_uts } from "repoV2/features/Common/modules/Location/constants/indianStatesUtsData";

/**
 * @deprecated
 * use `indian_states_and_uts` from `repoV2/features/Common/modules/Location/constants/indianStatesUtsData.ts`
 */
export const statesAndUtsOfIndia = indian_states_and_uts;
